/* ========================================================
    ** 全局Ajax拦截器处理 **
   ====================================================== */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from './config';
import ajaxLoading from './ajaxLoading';
import { isPlainObject, trim } from 'lodash';
import RootStore from '@stores';
// import { Toast } from '@components/dumb/toast';
import { getMessageByCode } from '../errorMap';
import i18n from '@translate/i18n';
// import i18n from '@translate/i18n';

interface AxiosRequest {
    url: string;
    data?: any;
    // moduleName: string;
    // methodName: string;
    config?: AxiosRequestConfig;
}

// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
        config.withCredentials = true
        // 时间戳阻止IE缓存
        // config.url += /\?/.test(config.url!) ? '&' : '?'+ `t=${+new Date()}`;
        // 清除放在header中的参数前後空格
        isPlainObject(config.params) && interceptorOfTrim(config.params);
        if (typeof config.data === 'string') config.data = JSON.parse(config.data);
        // 清除json参数前後空格
        isPlainObject(config.data) && interceptorOfTrim(config.data);
        //解決数组变成了对象
        // transformObjToArr(config.data);
        const language = i18n.language === 'zh-HK' ? 'zh-HK' : 'en-US';
        // 在发送请求之前做些什么

        config.headers = {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            platform: 'web',
            'Accept-Language': language,
            ...clearEmpty(config.headers),
            'Content-Type': 'application/json',
        };
        // config.paramsSerializer = paramsSerializer;
        ajaxLoading.show(config.url!, config.method!);
        console.log('axios config', config);
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        var config = error.config;
        const errorMessage = getMessageByCode('Network');
        // Toast.show({ msg: errorMessage });
        ajaxLoading.hide(config.url!, config.method!);
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        // 对响应数据做点什么
        var config = response.config,
            data = response?.data?.data || response?.data,
            status = response?.data?.code;
        //打印日志
        console.log(config.method, config.url);
        ajaxLoading.hide(config.url!, config.method!);
        // 系统错误
        // if (response?.status !== 200) {
        //     // envionment error
        //     return { ...response, data: { json: null, status: -1, success: false } };
        // }
        return { ...response, success: true };
    },
    function (error) {
        // 对响应错误做点什么
        const config = error.config,
            message: string = error.message;
        let errorStatus = '',
            errorMessage = '';

        if (message) {
            errorStatus = message.split('code')[1]?.replace(' ', '');
            errorMessage = getMessageByCode(errorStatus) || '';
        }
        // if (errorMessage) Toast.show({ msg: errorMessage });
        ajaxLoading.hide(config.url, config.method);
        // return Promise.resolve({ json: null, status: error.status, success: false });
        error.code = errorStatus;
        return Promise.reject(error);
    }
);

class Ajax {
    getErrorString = async (
        moduleName: string,
        methodName: string,
        code: number,
        data: any,
        config?: AxiosRequestConfig
    ) => {
        const url = '/myhkbn-login/api/' + moduleName + '/messageMap/' + methodName + '.json';
        const language = i18n.language === 'zh-HK' ? 'zh-HK' : 'en-US';
        console.log('getErrorString', { code, url });
        let res: AxiosResponse<any> = await axios.get(url);
        const errorCode = res.data.code[code.toString()];
        if (errorCode) {
            let errMsg = errorCode[language];
            if (errMsg && errMsg.includes('{data}') && data !== undefined) {
                // eslint-disable-next-line
                errMsg = errMsg.replace(new RegExp('\\${data}', 'g'), data);
                errMsg = errMsg.replace(new RegExp('{data}', 'g'), data);
            }
            if (errMsg) {
                data.rawErrorMessage = data.message;
                data.message = errMsg;
            }
        }
        console.warn({
            api: config?.url,
            method: config?.method,
            body: config?.data,
            response: data,
            apiErrorDescription: data.message || '',
        });

        return Promise.resolve({
            ...res,
            data: { json: data?.data, status: res.status, success: false, apiErrorDescription: data.message || '' },
        });
    };
    get = async (config: AxiosRequest) => {
        let res = await axios.get(config.url, config.config);
        // const isCallError = isCallErrorString(res);
        // if (isCallError) {
        //     return await this.getErrorString(
        //         config.moduleName,
        //         config.methodName,
        //         res.status,
        //         res?.data?.data,
        //         config.config
        //     );
        // }
        return res;
    };
    post = async (config: AxiosRequest) => {
        let res = await axios.post(config.url, config.config?.data, config.config);
        // const isCallError = isCallErrorString(res);
        // if (isCallError) {
        //     return await this.getErrorString(
        //         config.moduleName,
        //         config.methodName,
        //         res.status,
        //         res?.data?.data,
        //         config.config
        //     );
        // }
        return res;
    };
    put = async (config: AxiosRequest) => {
        let res = await axios.put(config.url, config.config?.data, config.config);
        // const isCallError = isCallErrorString(res);
        // if (isCallError) {
        //     return await this.getErrorString(
        //         config.moduleName,
        //         config.methodName,
        //         res.status,
        //         res?.data?.data,
        //         config.config
        //     );
        // }
        return res;
    };
    delete = async (config: AxiosRequest) => {
        let res = await axios.delete(config.url, config.config);
        const isCallError = isCallErrorString(res);
        // if (isCallError) {
        //     return await this.getErrorString(
        //         config.moduleName,
        //         config.methodName,
        //         res.status,
        //         res?.data?.data,
        //         config.config
        //     );
        // }
        return res;
    };
}

function interceptorOfTrim(params: any): any {
    Object.keys(params).forEach((key) => {
        if (!params[key]) return;
        else if (typeof params[key] === 'string' && (params[key].startsWith(' ') || params[key].endsWith(' ')))
            params[key] = trim(params[key]);
        else if (Array.isArray(params[key])) trimArray(params[key]);
        else return;
    });
    return params;
}

function trimArray(arr: any) {
    arr.forEach((v: any, k: number) => {
        if (!v) return;
        else if (v && typeof v === 'string') arr[k] = trim(v);
        else if (isPlainObject(v)) interceptorOfTrim(v);
    });
}

function clearEmpty(headers: any) {
    let _headers = headers,
        keys = Object.keys(_headers);
    if (keys.length) {
        keys.forEach((v) => (_headers[v] === null || _headers[v] === undefined) && (_headers[v] = ''));
    }
    return _headers;
}

/**
 * get 請求處理在url上傳遞數組序列化
 * actionTypes[]=xxx&actionTypes[]=xxx... ==> actionTypes=xxx&actionTypes=xxx
 * @param {any} params [description]
 */
function paramsSerializer(params: any) {
    let result = '',
        value: any,
        keys = Object.keys(params),
        length = keys.length;

    if (!length) return '';
    keys.forEach((key: any) => {
        value = params[key];
        if (typeof value === 'object') {
            'length' in value && Array.isArray(value) && (result += value.map((v) => `${key}=${v}`).join('&'));
        } else {
            result += `${key}=${value}`;
        }
        result += '&';
    });

    return result.substr(0, result.length - 1);
}

const isCallErrorString = (response: AxiosResponse) => {
    return false;
    if (response.status === 200 && response?.data?.code < 0) return true;
    return false;
};

function transformObjToArr(data: any, isRoot = true) {
    if (!data || typeof data !== 'object') return data;
    let dataNew: any = [];
    let keys = Object.keys(data);
    if (keys.includes('0')) {
        keys.forEach((k) => (dataNew[k] = transformObjToArr(data[k], false)));
    } else {
        keys.forEach((k) => {
            //刪除空對象，因爲無法判斷是空數組還是空對象，提交請求參數類型不對會報錯，所以刪除
            // if (!Object.keys(data[k]).length) delete data[k];
            // else
            // if (k === 'sameAsMasterAddress') console.log(data[k]);
            if (typeof data[k] === 'object' && !Object.keys(data[k]).length) data[k] = [];
            data[k] = transformObjToArr(data[k], false);
        });
    }
    if (isRoot) {
        return dataNew.length ? JSON.stringify(dataNew) : JSON.stringify(data);
    } else {
        return dataNew.length ? dataNew : data;
    }
}

export default new Ajax();
